import React from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

import AddOption from "./AddOption";
import async from "../../utils/service";

function EditQuestion({ questionData, setEditDialog, handleSubmit, delopIds, setdelOpids , refresh }) {
  const [regionList, setRegionList] = React.useState([]);
  const [question, setQuestion] = React.useState(questionData);
  const questionTypeList = ["Radio Type", "Checkbox", "Range Type"];
  const [channelList, setChannelList] = React.useState([])


  const handleQuestionChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setQuestion({
      ...question,
      [name]: value,
    });
  };
  const handleOptionChange = (event, optionId, index) => {
    let value = event.target.value;
    const optionsList = [...question.options];
    if (question.questionType === "Range Type"){
      if (optionId === 0){
        optionsList[0].minRange = value
      }
      else {
        optionsList[0].maxRange = value
      }
    }
    else{
      optionsList[optionId].optionText = value;
    }

    setQuestion({ ...question, options: optionsList });
  };

  const addOption = () => {
    setQuestion({
      ...question,
      options: [...question.options, { optionText: "" }],
    });
  };

  const deleteOption = (optionId, index) => {
    var opId = question.options[optionId].optionId
    if(opId !== undefined) {
      setdelOpids([...delopIds, opId])
    }
    // async.deleteOption(opId)
    // .then(resp => {
    // })
    // async.deleteOption()
    // var temp_ques = [...question]
    // temp_ques.options.splice
    setQuestion({
      ...question,
      questions: question.options.splice(optionId, 1),
    });
  };

  React.useEffect(() => {
    async.getChannels().then(resp => {
      setChannelList(resp.data)
      async.getChannelRegions().then(resp => {
        setRegionList(resp.data)
      })
    })
  }, []);


  const RenderEditFooter = () => {
    return (
      <div className="spacing1">
        <Button
          label="Discard"
          onClick={() => {setEditDialog(false); refresh(true);}}
          className="p-button  p-button-sm btn3"
          type="button"
        />
        <Button
          type = "submit"
          id = "question_button"
          label="Save"
          // onClick={() => handleSubmit(question)}
          className="p-button p-button-sm btn3"
        />
      </div>
    );
  };

  const formSubmit = (event) => {
    event.preventDefault();
    handleSubmit(question)
  }

  return (
    <div>
      <form onSubmit={formSubmit} id="question">
      <div className="p-fluid formgrid grid ">
        <div className="field col md:col-4 sm:col-12">
          <label className="label">* Channel</label>
          <MultiSelect
            name="channels"
            value={question.channels}
            options={channelList}
            optionLabel="channelName"
            optionValue="channelId"
            selectedItemsLabel="{0} channels selected"
            onChange={handleQuestionChange}
          />
        </div>

        <div className="field col md:col-4 sm:col-12">
          <label htmlFor="zip" className="label">
            * Region
          </label>
          <MultiSelect
            name="regions"
            value={question.regions}
            options={regionList}
            optionLabel="region"
            optionValue="regionId"
            selectedItemsLabel="{0} regions selected"
            onChange={handleQuestionChange}
          />
        </div>
        <div className="field col md:col-4 sm:col-12">
          <label className="label">* Question type</label>
          <Dropdown
            name="questionType"
            value={  question.questionType}
            options={questionTypeList}
            onChange={handleQuestionChange}
            required
          />
        </div>
        <div className="field col md:col-10 sm:col-12">
          <label htmlFor="firstname" className="label">
            * Question Text
          </label>
          <InputTextarea
            rows={2}
            cols={30}
            name="questionName"
            value={question.questionName}
            onChange={handleQuestionChange}
            required
          />
        </div>
        <AddOption
          //   index={index}
          addOption={addOption}
          question={question}
          handleOptionChange={handleOptionChange}
          deleteOption={deleteOption}
        />
      </div>
      
      <RenderEditFooter />
      </form>
    </div>
  );
}

export default EditQuestion;
